import { useState } from 'react';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.open(`https://www.google.com/search?q=${encodeURIComponent(searchQuery.trim() + ' 官网')}`, '_blank');
    }
  };

  return (
    <section className="relative w-full h-[420px] md:h-[560px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20abstract%20geometric%20composition%20with%20soft%20beige%20cream%20and%20warm%20white%20gradients%2C%20subtle%20compass%20and%20navigation%20motifs%2C%20clean%20modern%20aesthetic%2C%20gentle%20light%20texture%2C%20atmospheric%20and%20trustworthy%20feeling%2C%20no%20text%2C%20abstract%20background&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
        alt="正品蓝导航背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/40"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
          正品蓝导航
        </h1>
        <p className="text-base md:text-lg text-background-50/85 mb-8 max-w-2xl mx-auto leading-relaxed">
          专业权威的网址导航平台，汇聚海量正品网站资源<br className="hidden sm:block" />
          精准分类、安全可信，一站直达正品官网
        </p>

        <form onSubmit={handleSearch} className="max-w-xl mx-auto">
          <div className="flex items-center bg-background-50/95 backdrop-blur-sm rounded-full px-4 py-3 md:py-3.5 shadow-lg">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
              <i className="ri-search-line text-foreground-400 text-sm"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="搜索正品网站..."
              className="flex-1 ml-3 bg-transparent border-none outline-none text-sm text-foreground-900 placeholder:text-foreground-400"
            />
            <button
              type="submit"
              className="flex-shrink-0 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              搜索
            </button>
          </div>
        </form>

        <div className="flex flex-wrap items-center justify-center gap-3 mt-6">
          <span className="text-xs text-background-50/60">热门搜索：</span>
          {['淘宝', '京东', 'B站', '知乎', '新华网'].map((kw) => (
            <button
              key={kw}
              onClick={() => window.open(`https://www.google.com/search?q=${encodeURIComponent(kw + ' 官网')}`, '_blank')}
              className="text-xs text-background-50/80 hover:text-background-50 bg-background-50/10 hover:bg-background-50/20 px-3 py-1 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              {kw}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}